<template>
  <table class="base-table">
    <slot />
  </table>
</template>

<script>
export default {
  name: "BaseTable",
};
</script>

<style lang="scss">
@import "./base-table.scss";
</style>
